import { SERVER } from "../constants";
import { stringify } from "query-string";
import { MAP_URL } from "../constants/urls";
import { HttpClient } from "../utils/requests";

export function getArrayReference(resource, params) {
  const { page, perPage } = params.pagination;
  const { field, order } = params.sort;
  const query = {
    sort: JSON.stringify([field, order]),
    range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
    filter: JSON.stringify({
      ...params.filter,
      [params.target]: params.objectId,
    }),
  };
  const url = `${SERVER}/${MAP_URL[resource]}?${stringify(query)}`;
  return HttpClient(url).then(({ headers, json }) => {
    return {
      data: json.map((resource) => ({
        ...resource,
        id: resource.objectId,
        categoryId: resource.objectId,
      })),
      total: parseInt(headers.get("X-Total-Count").split("/").pop(), 10),
    };
  }
  );
}